var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Caption from "./Caption";
import Heading from "./Heading";
import Hint from "./Hint";
import Legend from "./Legend";
import StatusTag, { StatusTagState } from "./StatusTag";
import React from 'react';
import { space } from 'styled-system';
import { css, mq, styled } from "../utils";
var StyledCard = styled.div(function (_a) {
    var variant = _a.variant, legend = _a.legend, cards = _a.theme.components.cards;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: ", ";\n    margin: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n    border-radius: ", ";\n\n    ", "\n  "], ["\n    position: ", ";\n    margin: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n    border-radius: ", ";\n\n    ",
        "\n  "])), !!legend ? 'relative' : 'static', !!legend ? '1.5rem 0' : '1rem 0', cards.backgroundColor, cards.boxShadow, cards.borderRadius, mq({
        padding: cards[variant].padding,
    }));
}, space);
var CardLegend = styled(Legend)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translate(-50%);\n"], ["\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translate(-50%);\n"])));
var StyledHeader = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 2rem;\n\n  svg {\n    vertical-align: middle;\n  }\n"], ["\n  margin-bottom: 2rem;\n\n  svg {\n    vertical-align: middle;\n  }\n"])));
var Container = styled.div(function (_a) {
    var withStatus = _a.withStatus;
    return mq({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: ['wrap-reverse', 'wrap-reverse', 'nowrap'],
        h2: {
            width: ['100%', '100%', withStatus ? '75%' : '100%'],
            marginTop: ['1rem', '1rem', 0],
            marginRight: [0, 0, '1rem'],
        },
        img: {
            width: '80px',
            height: '40px',
        },
    });
});
var Card = function (_a) {
    var children = _a.children, title = _a.title, hint = _a.hint, caption = _a.caption, status = _a.status, icon = _a.icon, statusLabel = _a.statusLabel, onStatusClick = _a.onStatusClick, legend = _a.legend, legendColor = _a.legendColor, legendBgColor = _a.legendBgColor, props = __rest(_a, ["children", "title", "hint", "caption", "status", "icon", "statusLabel", "onStatusClick", "legend", "legendColor", "legendBgColor"]);
    return (React.createElement(StyledCard, __assign({ "data-component": "Card" }, props, { legend: legend }),
        legend && (React.createElement(CardLegend, { color: legendColor, bgColor: legendBgColor }, legend)),
        title && (React.createElement(StyledHeader, null,
            React.createElement(Container, { withStatus: !!status },
                React.createElement(Heading.Heading2, null,
                    title,
                    " ",
                    hint && React.createElement(Hint, null, hint)),
                status && (React.createElement(StatusTag, { status: status, onClick: onStatusClick }, statusLabel)),
                icon && icon),
            caption && React.createElement(Caption, { light: true }, caption))),
        children));
};
Card.defaultProps = {
    variant: 'large',
};
export default Card;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Card.js.map